import { useEffect, useRef, useState, type ReactNode } from 'react';

// <li> que se anima solo cuando entra en la pantalla (una vez). Sin IntersectionObserver se muestra de inmediato.
export function RevealItem({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLLIElement>(null);
  const [visible, setVisible] = useState(() => typeof IntersectionObserver === 'undefined');

  useEffect(() => {
    const node = ref.current;
    if (visible || !node) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '0px 0px -18% 0px' },
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [visible]);

  return (
    <li ref={ref} className={`reveal${visible ? ' reveal-visible' : ''}`}>
      {children}
    </li>
  );
}
